<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="fetch">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button type="primary" style="margin-right: 10px" @click="create"
          >创建税金账户</el-button
        >
      </div>
    </customize-page>
    <el-dialog
      width="300px"
      title="创建税金账户"
      :visible="showTaxAccountCreateForm"
      @close="showTaxAccountCreateForm = false"
    >
      <el-form :inline="true" :model="createTaxAccountForm">
        <el-form-item label="口岸">
          <el-select filterable v-model="createTaxAccountForm.portNid">
            <el-option
              v-for="item in portList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业">
          <el-select filterable v-model="createTaxAccountForm.enterpriseNid">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTaxAccountCreateForm = false">取消</el-button>
        <el-button type="primary" @click="createTaxAccount">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="400px"
      title="创建税金子账户"
      :visible="showCreateTaxSubAccountForm"
      @close="showCreateTaxSubAccountForm = false"
    >
      <el-form :inline="true" :model="createTaxSubAccountForm">
        <el-form-item label="口岸名称">
          {{ currentCreateSubAccountPortName }}
        </el-form-item>
        <el-form-item label="电商企业">
          {{ currentCreateSubAccountEnterpriseName }}
        </el-form-item>
        <el-form-item label="货主id">
          <el-input
            v-model="createTaxSubAccountForm.accountNid"
            placeholder="请输入货主id"
          />
        </el-form-item>
        <el-form-item label="预警金额">
          <el-input
            type="number"
            v-model="createTaxSubAccountForm.warnAmount"
            placeholder="请输入预警金额"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCreateTaxSubAccountForm = false">取消</el-button>
        <el-button type="primary" @click="createSubTaxAccount">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from "@/utils/common";
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions, mapGetters } from "vuex";
import taxAccountApi from "@/api/taxAccountApi";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      showTaxAccountCreateForm: false,
      showCreateTaxSubAccountForm: false,
      createTaxAccountForm: {},
      createTaxSubAccountForm: {},
      currentCreateSubAccountEnterpriseName: "",
      currentCreateSubAccountPortName: "",
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "子账号",
          type: "expand",
          render: (h, params) => {
            const data = params.row.subAccounts;
            return (
              <el-table
                border
                style="width: 100%"
                data={params.row.subAccounts}
              >
                <el-table-column
                  label="货主id"
                  prop="accountNid"
                ></el-table-column>
                <el-table-column
                  prop="expenseAmount"
                  label="消费金额"
                  formatter={(row, column, cellValue) => {
                    return `￥${cellValue / 100}`;
                  }}
                ></el-table-column>
                <el-table-column
                  prop="taxBalance"
                  label="税金余额"
                  formatter={(row, column, cellValue) => {
                    return `￥${cellValue / 100}`;
                  }}
                ></el-table-column>
                <el-table-column
                  prop="warnAmount"
                  label="预警金额"
                  formatter={(row, column, cellValue) => {
                    return `￥${cellValue / 100}`;
                  }}
                ></el-table-column>
              </el-table>
            );
          },
        },
        {
          title: "电商企业",
          key: "enterpriseName",
          align: "center",
          "min-width": 160,
        },
        {
          title: "充值金额",
          key: "rechargeAmount",
          align: "center",
          "min-width": 150,
          render: (h, params) => {
            let rechargeAmount = params.row.rechargeAmount;
            if (rechargeAmount == null) {
              return <div>0.00</div>;
            }
            let r = (parseInt(rechargeAmount) / 100).toFixed(2);
            return <div>{r}</div>;
          },
        },
        {
          title: "消费金额",
          width: 150,
          key: "expenseAmount",
          align: "center",
          render: (h, param) => {
            let expenseAmount = param.row.expenseAmount;
            if (expenseAmount == null) {
              return <div>0.00</div>;
            }
            return <div>{(parseInt(expenseAmount) / 100).toFixed(2)}</div>;
          },
        },
        {
          title: "税金余额",
          "min-width": 150,
          key: "taxBalance",
          align: "center",
          render: (h, param) => {
            let taxBalance = param.row.taxBalance;
            if (taxBalance == null) {
              return <div>0.00</div>;
            }
            return <div>{(parseInt(taxBalance) / 100).toFixed(2)}</div>;
          },
        },
        {
          title: "操作",
          width: 150,
          align: "center",
          fixed: "right",
          render: (h, param) => {
            let row = param.row;
            return (
              <a
                style={{ color: "#409EFF", padding: "0 10px" }}
                onClick={this.showCreateTaxSubAccount.bind(this, row)}
              >
                创建子账户
              </a>
            );
          },
        },
      ],
      filterObj: {
        // portNid: "NCPORT"
      },
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {
    ...mapGetters({
      getEECommerce: "getEECommerce",
      portList: "portList",
    }),
  },
  methods: {
    ...mapActions({
      queryPageExt: "ta/pageQuery",
    }),
    create() {
      this.showTaxAccountCreateForm = true;
    },
    showCreateTaxSubAccount(row) {
      console.log(row);
      this.showCreateTaxSubAccountForm = true;
      this.currentCreateSubAccountEnterpriseName = row.enterpriseName;
      this.currentCreateSubAccountPortName = row.portName;
      this.createTaxSubAccountForm = {
        accountType: "PROVIDER",
        portNid: row.portNid,
        enterpriseNid: row.enterpriseNid,
      };
    },
    createTaxAccount() {
      taxAccountApi
        .create({ request: this.createTaxAccountForm })
        .then((res) => {
          this.showTaxAccountCreateForm = false;
          this.fetch();
        });
    },
    createSubTaxAccount() {
      taxAccountApi
        .createSubAccount({
          request: {
            ...this.createTaxSubAccountForm,
            warnAmount: this.createTaxSubAccountForm.warnAmount * 100,
          },
        })
        .then((res) => {
          this.showCreateTaxSubAccountForm = false;
          this.fetch();
        });
    },
    fetch(data) {
      this.loading = true;
      const filterParams = this.getFilterParams();

      const sortObj = data ? data : this.sortObj;
      this.queryPageExt({
        ...sortObj,
        request: {
          ...filterParams,
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      })
        .then((res) => {
          this.loading = false;
          this.dataList = res.taxAccountEntities || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination = { ...this.pagination, ...pageInfo };
        })
        .catch((error) => {
          this.$message.error(error.msg || "未知错误");
        });
    },
    selectionChange(row) {
      this.currentRow = row;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [],
        },
      ];
    },
  },
};
</script>
